import React from 'react';

const EventArchive = () => {

  const archiveEventsData = [
    {
        title: 'Jamaica 60th Independence Celebration in Savannah, Georgia',
        image: 'https://unieros.com/wp/wp-content/uploads/2022/08/Saurico06-scaled.jpg',
      },
    {
      title: 'Bastille Day French Picnic in Savannah, Georgia',
      image: 'https://unieros.com/wp/wp-content/uploads/2022/08/Unieros_bastille_day_picnic_logo-scaled.jpg',
    },
    {
      title: 'Unieros Roots Rock Reggae Concert in Chicago',
      image: 'https://unieros.com/wp/wp-content/uploads/2016/06/SonTrio.jpg',
    },
    {
      title: 'Unieros Living Green for a Cause, Charity event in Chicago',
      image: 'https://unieros.com/wp/wp-content/uploads/2016/06/unierosLiving.jpg',
    },
    {
        title: 'Unieros World Cup Party in Chicago',
        image: 'https://unieros.com/wp/wp-content/uploads/2016/06/southAfrica.jpg',
      },
      {
        title: 'Unieros Fashion Show, in Chicago',
        image: 'https://unieros.com/wp/wp-content/uploads/2016/06/FashionShowLien.jpg',
      },
  ];

  return (
    <div className="past-events">
      <h2 className="text-center mb-4">Past Unieros Events</h2>
      <div className="row">
        {archiveEventsData.map((event, index) => (
          <div key={index} className="col-md-4">
            <div className="card event-card">
              <img src={event.image} className="card-img-top" alt={event.title} />
              <div className="card-body">
                <h5 className="card-title event-title">{event.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
   
        };


export default EventArchive;
